export function redirectAfterLogin(router, route = '/') {
  if (route && route !== '/login') {
    return router.push(route)
  }

  return router.push('/')
}

export function logoutAndRedirect(router, clearSession) {
  clearSession()
  return router.push('/')
}

export function reloadForServerPathChange() {
  location.reload()
}

export function refreshAccountState(loader) {
  return loader()
}
